import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    /**
     * Armazenar informação no LocalStorage
     *
     * @param key - Chave
     * @param value  - Valor que será armazenado
     */
    store(key: string, value: string): void {
        localStorage.setItem(key, value);
    }

    /**
     * Recuperar item do LocalStorage
     *
     * @param key - Chave do Item
     */
    get(key: string): string {
        return localStorage.getItem(key);
    }

    /**
     * Remover item do LocalStorage
     *
     * @param key - Chave do Item
     */
    remove(key: string): void {
        localStorage.removeItem(key);
    }

    /**
     * Limpar LocalStorage
     */
    clear(): void {
        localStorage.clear();
    }

}
